import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import isEmpty from "../validations/is-empty";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

const getTime = (date) => {
  const timezone = isEmpty(localStorage.getItem("timezoneMode"))
    ? "Europe/London"
    : localStorage.getItem("timezoneMode");

  const d = dayjs(date).tz(timezone);

  const amPm = d.hour() >= 12 ? "PM" : "AM";

  const hours = String(d.hour() % 12 || 12).padStart(2, "0");
  const minutes = String(d.minute()).padStart(2, "0");

  return `${hours}:${minutes} ${amPm}`;
};

export default getTime;
